/** Shared vocabulary for the offer screens, on both sides of the marketplace. */

export const OFFER_TONES = {
  DRAFT: 'neutral',
  SENT: 'info',
  ACCEPTED: 'success',
  // Declined reads the same here as a declined interview: a "no".
  DECLINED: 'danger',
  WITHDRAWN: 'neutral',
  EXPIRED: 'neutral',
};

export const OFFER_LABELS = {
  DRAFT: 'Draft',
  SENT: 'Awaiting answer',
  ACCEPTED: 'Accepted',
  DECLINED: 'Declined',
  WITHDRAWN: 'Withdrawn',
  EXPIRED: 'Expired',
};

/** What the candidate calls each state. "Awaiting answer" is their turn. */
export const STUDENT_OFFER_LABELS = {
  ...OFFER_LABELS,
  SENT: 'Needs your answer',
};

export const PERIOD_LABELS = {
  HOURLY: 'per hour',
  WEEKLY: 'per week',
  MONTHLY: 'per month',
  TOTAL: 'in total',
};

/** "€1,200 per month", or a plain statement when the placement is unpaid. */
export function stipendLine(offer) {
  if (offer.stipend_amount === null || offer.stipend_amount === undefined) {
    return 'No stipend stated';
  }
  const amount = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: offer.stipend_currency || 'EUR',
    maximumFractionDigits: 0,
  }).format(offer.stipend_amount);
  return `${amount} ${PERIOD_LABELS[offer.stipend_period] ?? ''}`.trim();
}

/** How the deadline should read to whoever is waiting on it. */
export function respondByLine(offer) {
  if (offer.status !== 'SENT') return null;
  const days = offer.days_to_respond;
  if (days === undefined || days === null) return null;
  if (days < 0) return 'The deadline has passed';
  if (days === 0) return 'Last day to answer';
  return `${days} ${days === 1 ? 'day' : 'days'} left to answer`;
}
